export default __webpack_public_path__ + "static/media/Armband of Brutal Carnage.0b971433.jpg";